import { RouteRecordRaw } from "vue-router";

export const warningTypeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/warning-types/:id/edit",
    name: "WarningTypeEdit",
    component: () => import("../views/WarningTypeEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "warningType",
      requiredRight: "viewUI",
    },
  },
];
